import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../../context';

const TextSearchDescriptions = ({ searchClass }) => {
    const codeDescriptionFilter = useSelector(state => state.daylight.codeDescriptionFilter);
    const dispatch = useDispatch();
    const [inputValue, setInputValue] = useState(codeDescriptionFilter);
    
    const setCodeDescriptionFilter = (string) => dispatch(actions.daylight.setCodeDescriptionFilter(string));

    useEffect(() => {
        const handler = setTimeout(() => {
            setCodeDescriptionFilter(inputValue);
        }, 500); // Set debounce delay here

        return () => clearTimeout(handler);
    }, [inputValue, dispatch]);

    const handleChange = (e) => {
        setInputValue(e.target.value);
    };

    return (
        <th scope="col" className="col col-medium">
            <input
                className={searchClass}
                type="search"
                placeholder="Filter Description"
                value={inputValue}
                onChange={handleChange}
            />
        </th>
    );
};

export default TextSearchDescriptions;
